import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
  AUTH_USER,
  SET_USER_AUTH,
  REQUEST_USER_INFO,
  RECEIVE_USER_INFO,
  MODIFY_USER_INFO,
  REQUEST_USER_PERM,
  RECEIVE_USER_PERM
} from '../constants'

import { fetchUserInfo, authUser, modifyUserInfo, fetchUserPerm } from '../services'

function* yieldAuthUser(action: any) {
  try {
    const response = yield call(authUser, action.payload)
    yield put({ type: SET_USER_AUTH, ...response })
  } catch (err) {
    console.log(err)
  }
}

function* yieldUser(action: any) {
  try {
    const response = yield call(fetchUserInfo)
    yield put({ type: RECEIVE_USER_INFO, ...response })
    // TODO:更好的回调方式，promise?
    if (action.callback) {
      action.callback(response)
    }
  } catch (err) {
    console.log(err)
  }
}

function* yieldUserPerm(action: any) {
  try {
    const response = yield call(fetchUserPerm)
    yield put({ type: RECEIVE_USER_PERM, perm: response })
  } catch (err) {
    console.log(err)
  }
}

function* yieldModifyUser(action: any) {
  try {
    yield call(modifyUserInfo, action.payload)
    yield put({ type: RECEIVE_USER_INFO, ...action.payload })
    // TODO:更好的回调方式，promise?
    action.callback()
  } catch (err) {
    console.log(err)
  }
}

export function* watchYieldUser() {
  yield all([
    takeLatest(AUTH_USER, yieldAuthUser),
    takeLatest(REQUEST_USER_INFO, yieldUser),
    takeLatest(REQUEST_USER_PERM, yieldUserPerm),
    takeLatest(MODIFY_USER_INFO, yieldModifyUser)
  ])
}



// WEBPACK FOOTER //
// ./src/saga/user.tsx